/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateBorrowerProjectCommand
 */
export interface UpdateBorrowerProjectCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateBorrowerProjectCommand
     */
    projectTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateBorrowerProjectCommand
     */
    insuranceProjectId: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateBorrowerProjectCommand
     */
    projectStartDate: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateBorrowerProjectCommand
     */
    projectName: string;
}

/**
 * Check if a given object implements the UpdateBorrowerProjectCommand interface.
 */
export function instanceOfUpdateBorrowerProjectCommand(value: object): value is UpdateBorrowerProjectCommand {
    if (!('projectTypeId' in value) || value['projectTypeId'] === undefined) return false;
    if (!('insuranceProjectId' in value) || value['insuranceProjectId'] === undefined) return false;
    if (!('projectStartDate' in value) || value['projectStartDate'] === undefined) return false;
    if (!('projectName' in value) || value['projectName'] === undefined) return false;
    return true;
}

export function UpdateBorrowerProjectCommandFromJSON(json: any): UpdateBorrowerProjectCommand {
    return UpdateBorrowerProjectCommandFromJSONTyped(json, false);
}

export function UpdateBorrowerProjectCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateBorrowerProjectCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'projectTypeId': json['projectTypeId'],
        'insuranceProjectId': json['insuranceProjectId'],
        'projectStartDate': (new Date(json['projectStartDate'])),
        'projectName': json['projectName'],
    };
}

export function UpdateBorrowerProjectCommandToJSON(json: any): UpdateBorrowerProjectCommand {
    return UpdateBorrowerProjectCommandToJSONTyped(json, false);
}

export function UpdateBorrowerProjectCommandToJSONTyped(value?: UpdateBorrowerProjectCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectTypeId': value['projectTypeId'],
        'insuranceProjectId': value['insuranceProjectId'],
        'projectStartDate': ((value['projectStartDate']).toISOString().substring(0,10)),
        'projectName': value['projectName'],
    };
}

